import React from 'react'

interface Props {
  size?: number
  className?: string
}

export const InstagramIcon = ({ size = 24, className }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M15.75 2H8.25C4.79875 2 2 4.79875 2 8.25V15.75C2 19.2012 4.79875 22 8.25 22H15.75C19.2012 22 22 19.2012 22 15.75V8.25C22 4.79875 19.2012 2 15.75 2ZM20.125 15.75C20.125 18.1625 18.1625 20.125 15.75 20.125H8.25C5.8375 20.125 3.875 18.1625 3.875 15.75V8.25C3.875 5.8375 5.8375 3.875 8.25 3.875H15.75C18.1625 3.875 20.125 5.8375 20.125 8.25V15.75Z"
      fill="white"
    />
    <path
      d="M12 7C9.23875 7 7 9.23875 7 12C7 14.7613 9.23875 17 12 17C14.7613 17 17 14.7613 17 12C17 9.23875 14.7613 7 12 7ZM12 15.125C10.2775 15.125 8.875 13.7225 8.875 12C8.875 10.2763 10.2775 8.875 12 8.875C13.7225 8.875 15.125 10.2763 15.125 12C15.125 13.7225 13.7225 15.125 12 15.125Z"
      fill="white"
    />
    <path
      d="M17.3752 7.29124C17.7432 7.29124 18.0415 6.99295 18.0415 6.62499C18.0415 6.25703 17.7432 5.95874 17.3752 5.95874C17.0073 5.95874 16.709 6.25703 16.709 6.62499C16.709 6.99295 17.0073 7.29124 17.3752 7.29124Z"
      fill="white"
    />
  </svg>
)
